// Lazy loader for the full game-icons set. The 6MB icon data lives in a static
// asset (public/build/game-icons.json, generated by scripts/generate-icons.cjs)
// and is fetched only when stickers are first used, so it never weighs down the
// main bundle. All game-icons share this viewBox.
import { writable } from "svelte/store";

export const ICON_VIEWBOX = "0 0 512 512";

// null until loaded, then { names: string[], icons: { [name]: body } }.
export const gameIcons = writable(null);

let loadPromise = null;

export function loadGameIcons() {
  if (loadPromise) {
    return loadPromise;
  }
  loadPromise = fetch("/build/game-icons.json")
    .then((r) => r.json())
    .then((set) => {
      const data = { names: Object.keys(set.icons).sort(), icons: set.icons };
      gameIcons.set(data);
      return data;
    })
    .catch((e) => {
      console.error("Failed to load the game-icons set:", e);
      loadPromise = null; // let a later attempt retry
      return null;
    });
  return loadPromise;
}
